import { render, staticRenderFns } from "./LeftTextNumber.vue?vue&type=template&id=5a783078&scoped=true"
import script from "./LeftTextNumber.vue?vue&type=script&lang=js"
export * from "./LeftTextNumber.vue?vue&type=script&lang=js"
import style0 from "./LeftTextNumber.vue?vue&type=style&index=0&id=5a783078&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a783078",
  null
  
)

export default component.exports